/* eslint-disable react-hooks/exhaustive-deps */
import {
  CameraOutlined,
  CopyOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Button, Col, Form, InputNumber, Radio, Row, Space, Tag, Tooltip, Typography, message } from "antd";
import CustomModal from "components/CustomModal";
import CustomTable from "components/CustomTable";
import CustomTextHiddenLine from "components/CustomTextHiddenLine";
import FormInput from "components/FormInput";
import { PrimaryButton } from "components/PrimaryButton";
import { INPUT_TYPE } from "config/constants";
import copy from "copy-to-clipboard";
import {
  useCreateQuotationSession,
  useCreateQuotationSessionSocial,
  useCreateQuotationSessionSuggestion,
} from "hooks/product/product";
import * as htmlToImage from "html-to-image";
import { t } from "i18next";
import { VAT_TYPE } from "pages/App/Product/constants";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { formatCurrency, handleCopyInfo, notify } from "utils/helperFuncs";
import PopoverPromotion from "../PopoverPromotion";
import "./index.scss";

const PRICE_DISPLAY_MODE = {
  FULL: "FULL",
  PARTIAL: "PARTIAL",
  HIDDEN: "HIDDEN",
};

// giữ lại chữ số đầu tiên của toàn bộ số, các chữ số còn lại thay bằng x
// vd: 300.000 -> 3xx.xxx, 1.000.000 -> 1.xxx.xxx
const maskPrice = (value) => {
  const groups = String(Math.round(Number(value) || 0))
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    .split(".");
  const firstGroup = groups[0].charAt(0) + "x".repeat(groups[0].length - 1);
  return `${[firstGroup, ...groups.slice(1).map(() => "xxx")].join(".")} ₫`;
};

const EXPORT_CELL_STYLE = (isHeader = false) => ({
  border: "1px solid #e8eaed",
  padding: "8px 12px",
  fontSize: 13,
  textAlign: "left",
  ...(isHeader && { background: "#f4f5f7", fontWeight: 600, textAlign: "center" }),
});

const QUOTATION_FORM = {
  xLINK: "LINK",
  INFO: "INFO",
  CREATE_ORDER: "CREATE_ORDER",
};

function ModalCopyProductPrice({ loading, data, handleSetSelectedRows, selectedRowKeys, handleSetSelectedRowKeys }) {
  const [form] = Form.useForm();

  console.log(data);
  const initialValues = data.map((item) => ({
    id: item?.id,
    code: item?.code,
    name: item?.name,
    price: item?.productPrices?.price,
    priceVat: item?.vatType !== VAT_TYPE.NOT_REQUIRED && item?.productPrices?.priceVat,
    oldPrice: item?.lastPriceLog?.oldPrice,
    newPrice: item?.lastPriceLog?.newPrice,
    oldPriceVat: item?.lastPriceLog?.oldPriceVat,
    newPriceVat: item?.lastPriceLog?.newPriceVat,
    lastPriceLog: item?.lastPriceLog,
    vatType: item?.vatType,
    exportVat: item?.vatType !== VAT_TYPE.NOT_REQUIRED,
    vatPercent: item?.vatPercent,
    oldVatPercent: item?.lastPriceLog?.oldVatPercent,
    newVatPercent: item?.lastPriceLog?.newVatPercent,
    warranty: item?.warrantyUnit === "YEAR" ? (item?.warranty || 0) * 12 : item?.warranty || 0,
    minOrderQuantity: item?.minOrderQuantity,
    quantity: 1,
    conditionPromotionProductsOnGoing: item?.conditionPromotionProductsOnGoing,
    belongLoyaltyPackagePeriods: item?.belongLoyaltyPackagePeriods,
    productDiscounts: item?.productDiscounts,
  }));
  const [quotaInit, setQuota] = useState(1);
  const [itemsCopy, setItemsCopy] = useState();
  const [quotationForm, setQuotationForm] = useState(QUOTATION_FORM.LINK);
  const [priceDisplayMode, setPriceDisplayMode] = useState(PRICE_DISPLAY_MODE.FULL);
  const [visible, setVisible] = useState(false);

  const { handleCreateQuotationSessionSuggestion, loading: loadingGenLink } = useCreateQuotationSessionSuggestion();
  const { handleCreateQuotationSession, loading: loadingQuotationSession } = useCreateQuotationSession();
  const { handleCreateQuotationSessionSocial, loading: loadingCreateQuotationSessionSocial } =
    useCreateQuotationSessionSocial();

  const openModal = () => {
    if (data?.length) {
      setVisible(true);
    } else {
      notify.warning({ message: t("product.errorMessage") });
      setVisible(false);
    }
  };

  const closeModal = () => {
    setQuota(1);
    setVisible(false);
  };

  const [showColumns, setShowColumns] = useState([
    {
      title: "GIÁ CÓ VAT",
      name: "priceVat",
      checked: true,
    },
  ]);

  const checkNullValue = (value) => {
    if (value === null || value === "" || value === undefined) {
      return "- -";
    } else {
      return value;
    }
  };

  const checkValueDuplicate = (price, lastPriceLog, oldValue, newValue) => {
    if (lastPriceLog) {
      if (oldValue.toString() === newValue.toString()) {
        return oldValue;
      } else
        return (
          <span>
            <div>{checkNullValue(oldValue)}</div>
            <div style={{ color: "#32BF46" }}>&nbsp;&#10142;&nbsp;{checkNullValue(newValue)}</div>
          </span>
        );
    } else {
      return price;
    }
  };

  const columns = [
    {
      title: (
        <Typography.Text style={{ color: "rgba(91, 102, 115, 1)" }} strong>
          STT
        </Typography.Text>
      ),
      align: "center",
      width: 50,
      render: (_, __, index) => index + 1,
    },

    {
      title: "THÔNG TIN SẢN PHẨM",
      width: 250,
      render: (_, record) => (
        <>
          <Link to={`/product/detail/${record?.id}`} target="_blank">
            <Typography.Link strong>{record?.code}</Typography.Link>
          </Link>
          <CustomTextHiddenLine text={record?.name} line={3} />
        </>
      ),
    },
    {
      title: "LOẠI % VAT",
      width: 150,
      align: "right",
      render: (_, record) =>
        checkValueDuplicate(
          `${record.vatPercent}%`,
          record?.lastPriceLog,
          `${record.oldVatPercent}%`,
          `${record.newVatPercent}%`
        ),
    },
    ...(quotationForm !== QUOTATION_FORM.LINK
      ? showColumns?.map((column, index) =>
          column?.checked
            ? {
                title: column?.title,
                dataIndex: ["productPrices", column?.name],
                width: 150,
                render: (_, record, index) => (
                  <FormInput
                    {...{
                      type: INPUT_TYPE.CURRENCY_INPUT,
                      formItemOptions: {
                        name: [index, column?.name],
                        rules: [
                          {
                            required: column?.name === "price",
                            message: "Không được để trống trường này!",
                          },
                        ],
                      },
                      inputOptions: {
                        min: 0,
                        maxLength: 11,
                      },
                    }}
                  />
                ),
              }
            : undefined
        )
      : [
          {
            title: "GIÁ CÓ VAT",
            width: 150,
            align: "right",
            render: (_, record) => {
              return (
                <div>
                  {checkValueDuplicate(
                    formatCurrency(record?.priceVat),
                    record?.lastPriceLog,
                    formatCurrency(record?.oldPriceVat),
                    formatCurrency(record?.newPriceVat)
                  )}
                </div>
              );
            },
          },
        ]),
    {
      title: "HÀNH ĐỘNG",
      align: "center",
      width: "10px",
      render: (_, record) => {
        const handleDelete = () => {
          const cloneItemsCopy = [...itemsCopy];
          const cloneData = [...data];
          const cloneDataRowKeys = [...selectedRowKeys];

          const newData = cloneData?.filter((item) => item?.id !== record?.id);
          const newItemsCopy = cloneItemsCopy?.filter((item) => item?.id !== record?.id);
          const newDataRowKeys = cloneDataRowKeys?.filter((item) => item !== record?.id);

          setItemsCopy(newItemsCopy);
          handleSetSelectedRows(newData);
          handleSetSelectedRowKeys(newDataRowKeys);
        };
        return (
          <div style={{ cursor: "pointer" }} onClick={handleDelete}>
            <DeleteOutlined />
          </div>
        );
      },
    },
  ].filter(Boolean);

  const deleteColumn = columns[columns.length - 1];

  const columnsLink = [
    columns[0],
    { ...columns[1], width: 280 },
    { ...columns[2], align: "center", width: 100 },
    {
      title: "SỐ LƯỢNG",
      align: "center",
      width: 130,
      render: (_, record, index) => (
        <FormInput
          {...{
            type: INPUT_TYPE.CURRENCY_INPUT,
            formItemOptions: {
              name: [index, "quantity"],
              rules: [
                { required: true, message: "Không được để trống trường này!" },
                {
                  warningOnly: true,
                  validator: (_, value) =>
                    record?.minOrderQuantity && value < record.minOrderQuantity
                      ? Promise.reject(new Error(`Chưa đạt số lượng MOQ tối thiểu (${record.minOrderQuantity})`))
                      : Promise.resolve(),
                },
              ],
            },
            inputOptions: {
              min: 1,
              maxLength: 11,
            },
          }}
        />
      ),
    },
    {
      title: "GIÁ CÓ VAT",
      width: 150,
      align: "center",
      render: (_, record) =>
        checkValueDuplicate(
          formatCurrency(record?.priceVat),
          record?.lastPriceLog,
          formatCurrency(record?.oldPriceVat),
          formatCurrency(record?.newPriceVat)
        ),
    },
    {
      title: "CTKM ĐANG THAM GIA",
      align: "center",
      width: 220,
      render: (_, record) => (
        <PopoverPromotion
          roundedTags
          productCode={record?.code}
          conditionPromotionProductsOnGoing={record?.conditionPromotionProductsOnGoing}
          belongLoyaltyPackagePeriods={record?.belongLoyaltyPackagePeriods}
          productDiscounts={record?.productDiscounts}
          price={record?.priceVat || record?.price}
        />
      ),
    },
    { ...deleteColumn, title: "HÀNH ĐỘNG", width: 100 },
  ];

  const columnsLinkCreateOrder = [
    {
      title: (
        <Typography.Text style={{ color: "rgba(91, 102, 115, 1)" }} strong>
          STT
        </Typography.Text>
      ),
      align: "center",
      width: 50,
      render: (_, __, index) => index + 1,
    },
    {
      title: "THÔNG TIN SẢN PHẨM",
      width: 300,
      render: (_, record) => (
        <>
          <Link to={`/product/detail/${record?.id}`} target="_blank">
            <Typography.Link strong>{record?.code}</Typography.Link>
          </Link>
          <CustomTextHiddenLine text={record?.name} line={3} />
        </>
      ),
    },
    {
      title: "LOẠI % VAT",
      dataIndex: "vatPercent",
      align: "center",
      width: 100,
      render: (_, record) => {
        return <span>{record.vatPercent >= 0 ? `${record.vatPercent}%` : "KCT"}</span>;
      },
      editable: "true",
    },
    {
      title: "ĐƠN GIÁ",
      width: 150,
      render: (_, record, index) => {
        return (
          <FormInput
            {...{
              type: INPUT_TYPE.CURRENCY_INPUT,
              formItemOptions: {
                name: [index, record?.vatType !== VAT_TYPE.NOT_REQUIRED ? "priceVat" : "price"],
                rules: [
                  {
                    required: true,
                    message: "Cần nhập giá cho sản phẩm này!",
                  },
                ],
              },
              inputOptions: {
                placeholder: "Giá mặc định của sản phẩm",
                min: 1,
                maxLength: 11,
              },
            }}
          />
        );
      },
    },
    {
      title: "SỐ LƯỢNG",
      width: 150,
      render: (_, record, index) => (
        <FormInput
          {...{
            type: INPUT_TYPE.CURRENCY_INPUT,
            formItemOptions: {
              name: [index, "quantity"],
              rules: [
                {
                  required: true,
                  message: "Không được để trống trường này!",
                },
              ],
            },
            inputOptions: {
              min: 1,
              maxLength: 11,
            },
          }}
        />
      ),
    },
    {
      title: "THỜI HẠN BẢO HÀNH (THÁNG)",
      width: 160,
      render: (_, record, index) => {
        return (
          <FormInput
            {...{
              type: INPUT_TYPE.CURRENCY_INPUT,
              formItemOptions: {
                name: [index, "warranty"],
                rules: [
                  {
                    required: true,
                    message: "Không được để trống trường này!",
                  },
                ],
              },
              inputOptions: {
                min: 0,
                maxLength: 2,
              },
            }}
          />
        );
      },
    },
    {
      title: "THÀNH TIỀN",
      width: 180,
      render: (_, record, index) => {
        const price =
          (record?.vatType !== VAT_TYPE.NOT_REQUIRED ? itemsCopy[index]?.priceVat : itemsCopy[index]?.price) || 0;
        const quantity = itemsCopy[index]?.quantity || 0;
        const total = price * quantity;
        return <Typography.Text strong>{formatCurrency(total)}</Typography.Text>;
      },
    },
    {
      title: "HÀNH ĐỘNG",
      width: 100,
      align: "center",
      render: (_, record) => {
        const handleDelete = () => {
          const cloneItemsCopy = [...itemsCopy];
          const newItemsCopy = cloneItemsCopy?.filter((item) => item?.id !== record?.id);
          setItemsCopy(newItemsCopy);
        };
        return (
          <div style={{ cursor: "pointer" }} onClick={handleDelete}>
            <DeleteOutlined />
          </div>
        );
      },
    },
  ].filter(Boolean);

  const formatPriceByMode = (value) =>
    priceDisplayMode === PRICE_DISPLAY_MODE.PARTIAL ? maskPrice(value) : formatCurrency(value);

  const formattedData = itemsCopy?.map(({ name, price, priceVat, vatType }) => {
    const selectedColumns = showColumns.filter((column) => column.checked);
    const rowData = [name];
    if (priceDisplayMode === PRICE_DISPLAY_MODE.HIDDEN) return rowData;
    selectedColumns.forEach((column) => {
      if (column.name === "price") {
        rowData.push(formatPriceByMode(price));
      } else if (column.name === "priceVat") {
        rowData.push(vatType !== VAT_TYPE.NOT_REQUIRED ? formatPriceByMode(priceVat) : "sp không xuất VAT");
      }
    });

    return rowData;
  });

  const textToCopy = formattedData?.map((row) => row.join("\t")).join("\n");

  const handleCopyTable = () => {
    copy(textToCopy);
    message.success(t("product.copyTypeTextSuccess"));
  };

  // bảng ẩn dùng để chụp ảnh: áp dụng chế độ hiển thị giá mà không ảnh hưởng UI nhập giá
  const exportTableRef = useRef(null);
  const [loadingCopy, setLoadingCopy] = useState(false);

  const copyTableToClipboard = async () => {
    setLoadingCopy(true);
    try {
      const table = exportTableRef.current;
      await htmlToImage
        .toPng(table, { backgroundColor: "#fff", style: { position: "static", left: "auto", top: "auto" } })
        .then((dataUrl) => {
          const blob = dataURLToBlob(dataUrl);
          // eslint-disable-next-line no-undef
          const item = new ClipboardItem({ [blob.type]: blob });
          navigator.clipboard
            .write([item])
            .then(() => {
              setLoadingCopy(false);
              message.success(t("product.copyTypeImageSuccess"));
            })
            .catch((error) => {
              console.error("Failed to copy table as image to clipboard:", error);
            });
        })
        .catch((error) => {
          console.error("Conversion failed:", error);
          setLoadingCopy(false);
        });
    } catch (error) {
      console.info(error);
    }
  };

  const dataURLToBlob = (dataURL) => {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    const n = bstr.length;
    const u8arr = new Uint8Array(n);
    for (let i = 0; i < n; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }
    return new Blob([u8arr], { type: mime });
  };

  const handleValuesChange = (changedValues, allValues) => {
    if (changedValues) {
      const newData = itemsCopy.map((item, index) => {
        return {
          ...item,
          price: allValues?.[index]?.price || item?.price,
          priceVat: allValues?.[index]?.priceVat || item?.priceVat,
          newPrice: allValues?.[index]?.newPrice || item?.newPrice,
          newPriceVat: allValues?.[index]?.newPriceVat || item?.newPriceVat,
          olePrice: allValues?.[index]?.olePrice || item?.olePrice,
          oldPriceVat: allValues?.[index]?.oldPriceVat || item?.oldPriceVat,
          vatType: allValues?.[index]?.vatType || item?.vatType,
          quantity: allValues?.[index]?.quantity || item?.quantity,
          warranty: allValues?.[index]?.warranty ?? item?.warranty,
          exportVat: allValues?.[index]?.exportVat || item?.exportVat,
        };
      });

      setItemsCopy(newData);
    }
  };

  const handleCopyLink = async () => {
    form.validateFields().then(async () => {
      try {
        const items = itemsCopy?.map((item) => ({
          productID: item.id,
          quantity: item.quantity,
          includedVAT: item?.exportVat,
          warranty: item?.warranty,
        }));

        await handleCreateQuotationSessionSuggestion({ items }).then((res) => {
          const dataRespon = res?.data?.product?.createQuotationSession;
          copy(`https://dlink.honganh.vn/product_quotation_detail?quotation_id=${dataRespon.id}`);
          message.success("Đã sao chép link vào bộ nhớ tạm");
        });
      } catch (error) {
        notify.error({ message: error.message });
      }
    });
  };

  const handleCopyLinkCreateOrder = async () => {
    form.validateFields().then(async () => {
      try {
        const dataQuotationSession = itemsCopy?.map((item) => ({
          productID: item.id,
          quantity: item.quantity,
          price: item.vatType !== VAT_TYPE.NOT_REQUIRED ? item.priceVat : item.price,
          includedVAT: item?.exportVat,
          warranty: item?.warranty,
          quota: item?.quota,
        }));
        const quota = quotaInit;

        await handleCreateQuotationSession({ items: dataQuotationSession, quota: quota }).then((res) => {
          const dataRespon = res?.data?.product?.createQuotationSession;
          const totalQuantity = itemsCopy?.reduce((sum, p) => sum + p.quantity, 0);
          const totalPrice = itemsCopy?.reduce(
            (sum, p) => sum + p.quantity * (p.vatType !== VAT_TYPE.NOT_REQUIRED ? p.priceVat : p.price),
            0
          );

          const dynamicLayout = [
            "THÔNG TIN BÁO GIÁ",
            `• Tổng số sản phẩm: ${totalQuantity} sản phẩm`,
            `• Tổng thành tiền: ${formatCurrency(totalPrice)}`,
            "• Danh sách sản phẩm:",
            ...itemsCopy?.map(
              (product, idx) =>
                `**${idx + 1}. ${product.name}**  \n` +
                `   • Giá ${product.exportVat ? "bao gồm VAT" : "chưa gồm VAT"}: ${formatCurrency(product.vatType !== VAT_TYPE.NOT_REQUIRED ? product.priceVat : product.price)}  \n` +
                `   • Số lượng: ${product.quantity}`
            ),
            "*<w>Lưu ý: Thời hạn tạo đơn hàng của bạn chỉ có 24 giờ kể từ thời điểm hệ thống tạo danh sách sản phẩm theo thông tin báo giá trên. Để đảm bảo quyền lợi, vui lòng tạo đơn hàng ngay khi nhận được thông tin để tránh hết hạn đặt hàng.</w>*",
            `*<Button data=${JSON.stringify({ id: dataRespon.id, expirationTime: dataRespon.expirationTime })}>add_to_cart</Button>*`,
          ].join("\n");
          handleCopyInfo({
            copyValue: dynamicLayout,
            messageSuccess: "Đã sao chép link vào bộ nhớ tạm",
          });
        });
      } catch (error) {
        notify.error({ message: error.message });
      }
    });
  };

  const handleCopyLinkShareSocial = async () => {
    form.validateFields().then(async () => {
      try {
        const dataQuotationSession = itemsCopy?.map((item) => ({
          productID: item.id,
          quantity: item.quantity,
          price: item.vatType !== VAT_TYPE.NOT_REQUIRED ? item.priceVat : item.price,
          includedVAT: item?.exportVat,
          warranty: item?.warranty,
          quota: item?.quota,
        }));
        const quota = quotaInit;

        await handleCreateQuotationSessionSocial({
          items: dataQuotationSession,
          quota: quota,
        }).then((res) => {
          const dataRespon = res?.data?.product?.createQuotationSession;
          const totalQuantity = itemsCopy?.reduce((sum, p) => sum + p.quantity, 0);
          const totalPrice = itemsCopy?.reduce(
            (sum, p) => sum + p.quantity * (p.vatType !== VAT_TYPE.NOT_REQUIRED ? p.priceVat : p.price),
            0
          );

          const dynamicLayout = [
            "THÔNG TIN BÁO GIÁ",
            `• Tổng số sản phẩm: ${totalQuantity} sản phẩm`,
            `• Tổng thành tiền: ${formatCurrency(totalPrice)}`,
            "• Danh sách sản phẩm:",
            ...itemsCopy?.map(
              (product, idx) =>
                `${idx + 1}. ${product.name} \n` +
                `   • Giá ${product.exportVat ? "bao gồm VAT" : "chưa gồm VAT"}: ${formatCurrency(product.vatType !== VAT_TYPE.NOT_REQUIRED ? product.priceVat : product.price)}  \n` +
                `   • Số lượng: ${product.quantity}`
            ),
            "Lưu ý: Thời hạn tạo đơn hàng của bạn chỉ có 24 giờ kể từ thời điểm hệ thống tạo danh sách sản phẩm theo thông tin báo giá trên. Để đảm bảo quyền lợi, vui lòng tạo đơn hàng ngay khi nhận được thông tin để tránh hết hạn đặt hàng.",
            `👉 Bấm vào link sau để xem và thêm các sản phẩm vào giỏ hàng: https://dlink.honganh.vn/product_quotation_detail?quotation_id=${dataRespon.id}`,
          ].join("\n");

          handleCopyInfo({
            copyValue: dynamicLayout,
            messageSuccess: "Đã sao chép link vào bộ nhớ tạm",
          });
        });
      } catch (error) {
        notify.error({ message: error.message });
      }
    });
  };

  const linkTotalQuantity = itemsCopy?.reduce((sum, p) => sum + (p.quantity || 0), 0) || 0;
  const linkTotalAmount =
    itemsCopy?.reduce(
      (sum, p) => sum + (p.quantity || 0) * ((p.vatType !== VAT_TYPE.NOT_REQUIRED ? p.priceVat : p.price) || 0),
      0
    ) || 0;

  const warningTexts = {
    [QUOTATION_FORM.LINK]: "Lưu ý: Link sao chép sẽ điều hướng đại lý mở app.",
    [QUOTATION_FORM.CREATE_ORDER]: `Lưu ý: Thông tin sau khi sao chép khi được gửi qua Chatwoot hoặc nền tảng xã hội khác, sẽ giúp đại lý chọn sản phẩm và thêm vào giỏ hàng trên App. Vui lòng gửi thông tin sao chép đến đại lý ngay sau khi sao chép để đảm bảo họ có đủ thời gian tạo đơn hàng trong khung 24 giờ kể từ thời điểm sao chép.`,
  };

  const tablePropsByForm = {
    [QUOTATION_FORM.LINK]: {
      columns: columnsLink,
      ...(itemsCopy?.length > 10 && {
        scroll: {
          x: "max-content",
          y: "500px",
        },
      }),
    },
    [QUOTATION_FORM.INFO]: {
      columns,
    },
    [QUOTATION_FORM.CREATE_ORDER]: {
      columns: columnsLinkCreateOrder,
    },
  };

  const copyActions = {
    [QUOTATION_FORM.LINK]: () => <PrimaryButton title="Sao chép" onClick={handleCopyLink} loading={loadingGenLink} />,
    [QUOTATION_FORM.INFO]: () => (
      <Space>
        <Button onClick={copyTableToClipboard} loading={loadingCopy} icon={<CameraOutlined />} type="primary">
          {t("product.copyTypeImage")}
        </Button>
        <Button onClick={handleCopyTable} icon={<CopyOutlined />} type="primary">
          {t("product.copyTypeText")}
        </Button>
      </Space>
    ),
    [QUOTATION_FORM.CREATE_ORDER]: () => (
      <Space>
        <PrimaryButton
          title="Sao chép qua Chatwoot"
          onClick={handleCopyLinkCreateOrder}
          loading={loadingQuotationSession}
        />
        <PrimaryButton
          title="Sao chép qua nền tảng khác"
          onClick={handleCopyLinkShareSocial}
          loading={loadingCreateQuotationSessionSocial}
        />
      </Space>
    ),
  };

  useEffect(() => {
    setItemsCopy([...initialValues]);
    form.setFieldsValue({ ...initialValues });
    form.validateFields();
  }, [JSON.stringify(data)]);

  useEffect(() => {
    setItemsCopy([...initialValues]);
    form.resetFields();
    form.validateFields();
  }, [visible]);

  return (
    <div>
      <CustomModal
        customComponent={<Typography.Text>Sao chép báo giá</Typography.Text>}
        title={
          <Typography.Title level={4} style={{ textAlign: "center" }}>
            {t("product.infoProducPrice")}
          </Typography.Title>
        }
        cancelButtonLabel="Hủy bỏ"
        closable={false}
        centered
        footer={false}
        buttonLoading={loading}
        width={quotationForm === QUOTATION_FORM.CREATE_ORDER ? "70%" : "55%"}
        hideConfirmButton
        onOpen={openModal}
        onCancel={closeModal}
        visible={visible}
        addMoreButton={(copyActions[quotationForm] || (() => null))()}
      >
        <Row gutter={[16, 16]} className="modal-copy-product-price">
          <Col span={24}>
            <Row>
              <Col span={4}>
                <Typography>
                  <Typography.Text strong>Hình thức báo giá </Typography.Text>
                  <span style={{ color: "red" }}>*</span>
                </Typography>
              </Col>
              <Col>
                <Radio.Group
                  defaultValue={quotationForm}
                  value={quotationForm}
                  onChange={(e) => setQuotationForm(e.target.value)}
                >
                  <Radio value={QUOTATION_FORM.LINK}>Sao chép link báo giá</Radio>
                  <Radio value={QUOTATION_FORM.INFO}>Sao chép thông tin báo giá</Radio>
                  <Radio value={QUOTATION_FORM.CREATE_ORDER}>Sao chép link báo giá tích hợp tạo đơn</Radio>
                </Radio.Group>
              </Col>
            </Row>
          </Col>

          {quotationForm === QUOTATION_FORM.CREATE_ORDER && (
            <Col span={24}>
              <Row gutter={[16, 16]} align="middle">
                <Col flex="none" style={{ whiteSpace: "nowrap" }}>
                  <Typography.Text strong>Số lượt sử dụng link tối đa</Typography.Text>
                  <span style={{ color: "red" }}>*</span>
                  <Tooltip
                    title={
                      <span>
                        Giới hạn tổng số lần đại lý được phép sử dụng link báo giá để tạo đơn hàng. Khi đạt số lượt tối
                        đa, link sẽ không còn hiệu lực sử dụng.
                      </span>
                    }
                  >
                    <QuestionCircleOutlined />
                  </Tooltip>
                </Col>
                <Col flex="70px">
                  <InputNumber
                    min={1}
                    value={quotaInit}
                    onChange={(value) => {
                      if (!value || value < 1) {
                        setQuota(1);
                      } else {
                        setQuota(value);
                      }
                    }}
                    style={{ width: "100%" }}
                    placeholder="Lượt"
                  />
                </Col>
              </Row>
            </Col>
          )}

          {quotationForm === QUOTATION_FORM.INFO && (
            <Col span={24}>
              <div className="modal-copy-product-price__price-mode">
                <Typography.Text strong>
                  Chế độ hiển thị giá:{" "}
                  <i style={{ fontWeight: "normal", fontSize: 12 }}>(Định dạng hiển thị khi đại lý nhận giá)</i>
                </Typography.Text>
                <Radio.Group value={priceDisplayMode} onChange={(e) => setPriceDisplayMode(e.target.value)}>
                  <Radio value={PRICE_DISPLAY_MODE.FULL}>
                    Toàn bộ <i>(15.000đ)</i>
                  </Radio>
                  <Radio value={PRICE_DISPLAY_MODE.PARTIAL}>
                    Ẩn một phần <i>(1x.xxxđ)</i>
                  </Radio>
                  <Radio value={PRICE_DISPLAY_MODE.HIDDEN}>Ẩn giá</Radio>
                </Radio.Group>
              </div>
            </Col>
          )}

          {warningTexts[quotationForm] && (
            <Col span={24}>
              <Typography.Text type="warning">{warningTexts[quotationForm]}</Typography.Text>
            </Col>
          )}

          <Col span={24}>
            <Form form={form} initialValues={initialValues} onValuesChange={handleValuesChange}>
              <div>
                <CustomTable
                  rowKey={(record) => record?.id}
                  bordered
                  dataSource={itemsCopy}
                  {...tablePropsByForm[quotationForm]}
                />
              </div>
            </Form>
          </Col>
          {quotationForm === QUOTATION_FORM.INFO && (
            <div className="modal-copy-product-price__export">
              <div ref={exportTableRef} style={{ width: 760, padding: 16, background: "#fff" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      {[
                        "STT",
                        "THÔNG TIN SẢN PHẨM",
                        "LOẠI % VAT",
                        ...(priceDisplayMode === PRICE_DISPLAY_MODE.HIDDEN ? [] : ["GIÁ CÓ VAT"]),
                      ].map((title) => (
                        <th key={title} style={EXPORT_CELL_STYLE(true)}>
                          {title}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {itemsCopy?.map((item, index) => (
                      <tr key={item.id}>
                        <td style={{ ...EXPORT_CELL_STYLE(), textAlign: "center" }}>{index + 1}</td>
                        <td style={EXPORT_CELL_STYLE()}>
                          <div style={{ color: "#2246dc", fontWeight: 600 }}>{item.code}</div>
                          <div>{item.name}</div>
                        </td>
                        <td style={{ ...EXPORT_CELL_STYLE(), textAlign: "center" }}>
                          {item.vatPercent >= 0 ? `${item.vatPercent}%` : "KCT"}
                        </td>
                        {priceDisplayMode !== PRICE_DISPLAY_MODE.HIDDEN && (
                          <td style={{ ...EXPORT_CELL_STYLE(), textAlign: "right" }}>
                            {item.vatType !== VAT_TYPE.NOT_REQUIRED
                              ? formatPriceByMode(item.priceVat)
                              : "sp không xuất VAT"}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {quotationForm === QUOTATION_FORM.LINK && (
            <>
              <Col span={24} className="modal-copy-product-price__summary">
                <Typography.Text strong>Tổng sản phẩm: {linkTotalQuantity}</Typography.Text>
                <Typography.Text strong>Tổng tiền: {formatCurrency(linkTotalAmount)}</Typography.Text>
              </Col>
              <Col span={24}>
                <Typography.Text>
                  <InfoCircleOutlined />{" "}
                  <i>
                    <strong>Lưu ý:</strong> Giá hiển thị là giá niêm yết, chưa bao gồm các chương trình khuyến mãi. Tùy
                    từng tài khoản, đại lý có thể được áp dụng voucher/ưu đãi khác nhau nên giá thực tế có thể thấp hơn.
                    Vui lòng thông báo với khách hàng về nội dung này khi báo giá
                  </i>
                </Typography.Text>
              </Col>
            </>
          )}
          {quotationForm === QUOTATION_FORM.CREATE_ORDER &&
            (() => {
              const totalQuantity = itemsCopy?.reduce((sum, p) => sum + p.quantity, 0) || 0;
              const totalAmount =
                itemsCopy?.reduce(
                  (sum, p) => sum + p.quantity * (p.vatType !== VAT_TYPE.NOT_REQUIRED ? p.priceVat : p.price),
                  0
                ) || 0;
              return (
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  {totalQuantity > 0 && (
                    <Tag color="blue" className="custom-tag-blue">
                      Tổng số lượng: <strong>{totalQuantity} sản phẩm</strong>
                    </Tag>
                  )}
                  {totalAmount > 0 && (
                    <Tag color="blue" className="custom-tag-blue">
                      Tổng thành tiền tạm tính: <strong>{formatCurrency(totalAmount)}</strong>
                    </Tag>
                  )}
                </Col>
              );
            })()}
        </Row>
      </CustomModal>
    </div>
  );
}

export default ModalCopyProductPrice;
